export const parseValue = value => {
  if (value && typeof value === 'string' && value.match(/^[\{\]]/)) {
    try {
      return JSON.parse(value)
    } catch (err) {
      // Do nothing
    }
  }

  return value
}
